import { useQuery } from '@apollo/client/react';

import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { getIsLoadingQuery } from '@utils/getIsLoadingQuery';
import { getBundleBasket } from '@utils/queries/getBasket';

const useBasketQuery = () => {
  const { basketId } = useBasketContext();
  const {
    data: basketData,
    networkStatus,
    error,
  } = useQuery(getBundleBasket, {
    variables: { basketId },
  });

  return {
    isLoading: getIsLoadingQuery(networkStatus, basketData),
    basketData,
    error,
  };
};

export { useBasketQuery };
